import { render, staticRenderFns } from "./form.vue?vue&type=template&id=e6e80dc2"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6e80dc2')) {
      api.createRecord('e6e80dc2', component.options)
    } else {
      api.reload('e6e80dc2', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=e6e80dc2", function () {
      api.rerender('e6e80dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/whitelist-ip/form.vue"
export default component.exports